import { createSlice } from '@reduxjs/toolkit';
import { emptyFormState } from '../emptyState';
import { postStatus } from '../status';
import { postForgotPassword } from 'api';

// Then, handle actions in your reducers:
const forgotPasswordSlice = createSlice({
  name: 'forgotPassword',
  emptyFormState,
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
    forgotPasswordPostStart: (state) => {
      state.status = postStatus.POST_START;
      state.fetching = true;
      state.error = false;
    },
    forgotPasswordPostSuccess: (state, { payload }) => {
      state.status = postStatus.POST_SUCCESS;
      state.payload = payload;
      state.fetching = false;
      state.error = false;
    },
    forgotPasswordPostFail: (state, { payload }) => {
      state.status = postStatus.POST_FAIL;
      state.payload = payload;
      state.fetching = false;
      state.error = true;
    },
    forgotPasswordFormReset: (state) => {
      state.status = null;
      state.payload = null;
      state.fetching = false;
      state.error = false;
    },
  },
});

// actions generated from the slice, TODO: remove start,success,fail
export const {
  forgotPasswordPostStart,
  forgotPasswordPostSuccess,
  forgotPasswordPostFail,
  forgotPasswordFormReset,
} = forgotPasswordSlice.actions;

// The reducer
export const forgotPasswordReducer = forgotPasswordSlice.reducer;

// Asynchronous thunk action
export const forgotPasswordPost = (formData) => (dispatch) => {
  dispatch(forgotPasswordPostStart());

  postForgotPassword(formData)
    .then((payload) => {
      dispatch(forgotPasswordPostSuccess(payload));
    })
    .catch((error) => {
      dispatch(forgotPasswordPostFail(error));
    });
};
